import "../../../styles/Auth/report.css";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from "recharts";
import { useEffect, useState } from "react";
import { getData } from '../../../webService/webservice';

const MONTHS = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];

const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
        return (
            <div className="bg-[#6d214f] text-white px-3 py-2 rounded-lg shadow-md">
                <p className="text-sm font-medium">{payload[0].payload.month}</p>
                {payload.map((item) => (
                    <p key={item.dataKey} className="text-sm">
                        {item.dataKey === "revenue" ? "Revenue" : "Tax"}:
                        ₹{Number(item.value).toLocaleString()}
                    </p>
                ))}
            </div>
        );
    }
    return null;
};


const EarningReport = ({ sessionToken }) => {
    const [chartData, setChartData] = useState([]);
    const [totalRevenue, setTotalRevenue] = useState(0);
    const [selectedMonth, setSelectedMonth] = useState(MONTHS[new Date().getMonth()]);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [loading, setLoading] = useState(false);

    const years = Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i);

    const fetchData = async (year) => {
        try {
            setLoading(true);

            const response = await getData(
                `reports/reports/revenue?year=${year}`,
                {},
                sessionToken
            );

            const monthlyData = response?.data?.monthly || [];

            // Normalize monthly data (make sure all 12 months appear)
            const normalizedData = MONTHS.map((m) => {
                const monthObj = monthlyData.find(d => d.month === m) || {
                    revenue: 0,
                    tax: 0,
                    items: 0,
                    qty: 0
                };
                return {
                    month: m,
                    revenue: monthObj.revenue,
                    tax: monthObj.tax,
                    items: monthObj.items,
                    qty: monthObj.qty
                };
            });

            setChartData(normalizedData);

            // Set total revenue for selected month
            const selectedData = normalizedData.find(d => d.month === selectedMonth) || { revenue: 0 };
            setTotalRevenue(selectedData.revenue);

        } catch (error) {
            console.error("Error fetching earning report:", error);
        } finally {
            setLoading(false);
        }
    };

    // Update totalRevenue when month or chartData changes
    useEffect(() => {
        const selectedData = chartData.find(d => d.month === selectedMonth) || { revenue: 0 };
        setTotalRevenue(selectedData.revenue);
    }, [selectedMonth, chartData]);

    // Fetch data when year changes
    useEffect(() => {
        fetchData(selectedYear);
    }, [selectedYear]);

    return (
        <div className='summary-layout1'>
            <div className="summary-content1">
                <main className="summary-main1">
                    <h2>Select Year</h2>

                    <div className='date-range' style={{ display: 'flex', gap: '1rem', marginBottom: '1rem', alignItems: 'center' }}>
                        <div className='year-select'>
                            <label htmlFor="year" className="input-label">Year</label>
                            <select
                                name="year"
                                className="date-input"
                                value={selectedYear}
                                onChange={(e) => setSelectedYear(parseInt(e.target.value))}
                            >
                                {years.map((y, idx) => (
                                    <option key={idx} value={y}>{y}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <h3>Earning Report</h3>
                    <div className="earning-report-container">
                        <h2 className="earning-title">₹{totalRevenue.toLocaleString()}</h2>
                        <p className="earning-subtitle" style={{ color: '#A16A70', fontWeight: 600 }}>
                            Total Revenue
                        </p>

                        <ResponsiveContainer width="100%" height={280}>
                            <LineChart data={chartData}>
                                <XAxis dataKey="month" />
                                <YAxis />
                                <Tooltip content={<CustomTooltip />} />
                                <Legend />

                                {/* Revenue */}
                                <Line
                                    type="monotone"
                                    dataKey="revenue"
                                    stroke="#A16A70"
                                    strokeWidth={3}
                                    dot={false}
                                />

                                {/* Tax (optional) */}
                                <Line
                                    type="monotone"
                                    dataKey="tax"
                                    stroke="#f6b93b"
                                    strokeWidth={3}
                                    dot={false}
                                />
                            </LineChart>
                        </ResponsiveContainer>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default EarningReport;
